import { normalizeGeneratedArtifactPrompt } from '@/utils/generatedArtifactAssistantPayloadPatterns.js'

/** @param {string} trimmed */
export function isCreateAgentQuestionPrompt(trimmed) {
  return normalizeGeneratedArtifactPrompt(trimmed).toLowerCase() === 'create'
}
